/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';

export interface DeckInvestmentCompanyCreate {
  readonly id: string;
  readonly name: string;
  readonly organization_number: string | null;
  readonly giin: string | null;
  readonly utl: string | null;
  readonly logo: string;
  readonly address: Address;
  readonly website: string;
  readonly added_by: string;
}
